'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isLineDisabled"];
import { FLINT, KOALA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "FilterEditorAndSeparator__Wrapper",
  componentId: "w7skw1-0"
})(["color:", ";line-height:1rem;"], FLINT);
const VerticalLine = styled.div.withConfig({
  displayName: "FilterEditorAndSeparator__VerticalLine",
  componentId: "w7skw1-1"
})(["margin-left:12px;height:", ";border-left:1px solid ", ";"], ({
  height = '8px'
}) => height, KOALA);
const FilterEditorAndSeparator = props => {
  const {
      isLineDisabled
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs(Wrapper, Object.assign({}, rest, {
    children: [!isLineDisabled && /*#__PURE__*/_jsx(VerticalLine, {
      height: "8px"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFilters.FilterEditorOperatorDisplayList.separatorAnd"
    }), !isLineDisabled && /*#__PURE__*/_jsx(VerticalLine, {
      height: "7px"
    })]
  }));
};
FilterEditorAndSeparator.propTypes = {
  isLineDisabled: PropTypes.bool.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
FilterEditorAndSeparator.defaultProps = {
  isLineDisabled: false
};
export default FilterEditorAndSeparator;